import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaCircleXmark } from "react-icons/fa6";
import BeatLoader from "react-spinners/BeatLoader";
import { Button, Input } from "../CustomComponents";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import Toast, { ErrorToast, SuccessToast } from "../../Hooks/useToast";
import {
  useAddCategoryMutation,
  useUpdateCategoryMutation,
} from "../../Data/services/trainingApi";
import UserAvatarWithNameAndTag from "../UserAvatar/UserAvatarWithNameAndTag";
import LineRow from "../CustomComponents/LineRow";
import { useUpdateRequestMutation } from "../../Data/services/profileRequestApi";
import moment from "moment";

const ClassEnrollmentModal = ({
  handleUpdateModalClose,
  data,
  handleUpdate,
  refetch,
}) => {
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({});

  const [rowId, setRowId] = useState("");
  const [userSlug, setUserSlug] = useState("");

  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedQuestionType, setSelectedQuestionType] = useState("");

  const statusType = [
    {
      id: 20,
      name: "Approved",
    },
    {
      id: 30,
      name: "Rejected",
    },
  ];

  const statusTypeList = statusType.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (data) {
      console.log(data);
      setRowId(data.id);
      // setUserSlug(data.id);
      // setValue("name", data.name);
    }
  }, [data, mounted]);

  const handleStatusChange = (value) => {
    // console.log(value);
    setSelectedStatus(value);
  };

  const [updateStatus, { isLoading: updating }] = useUpdateRequestMutation();

  // const handleSendData = async (record) => {
  //   console.log(record);
  //   console.log(rowId);

  //   try {

  //     const response = await updateStatus({ data: record, id: rowId }).unwrap();

  //     console.log(response);

  //     if (response?.error?.status === 400) {
  //       console.log(response?.error?.data?.message);
  //       ErrorToast(response?.error?.data?.message, "error");
  //     }

  //     if (response?.error?.status === 500) {
  //       ErrorToast(response?.error?.data?.message, "error");
  //     }

  //     if (response.code === 200) {
  //       SuccessToast(response?.message);
  //       handleUpdateModalClose();
  //       refetch();
  //     }
  //   } catch (error) {
  //     if (error?.response && error?.response?.data?.message) {
  //       Toast(error?.response?.data?.message, "error");
  //     }
  //   }
  // };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleUpdateModalClose}>
        <div
          className={cssStyles.modalContainer}
          style={{ maxWidth: "90%", height: "80vh" }}
        >
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-semibold m-0 black-text">Details</p>
            <span className="bg-white bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleUpdateModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Row className="w-100">
              <Col sm={12} md={6}>
                <LineRow heading={"Title"} text={data?.class_enrolled?.title || '-'} />
                <LineRow
                  heading={"Event Name"}
                  text={data?.class_enrolled?.event_name || '-'}
                />
                <LineRow
                  heading={"Description"}
                  text={data?.class_enrolled?.description || '-'}
                />
                <LineRow
                  heading={"Location"}
                  text={data?.class_enrolled?.location || '-'}
                />
                <LineRow
                  heading={"Start at"}
                  text={moment(data?.class_enrolled?.start_at).format(
                    "YYYY-MM-DD HH:mm A"
                  )}
                />
                <LineRow
                  heading={"Host Name"}
                  text={data?.class_enrolled?.host_name || '-'}
                />
                <LineRow
                  heading={"Host Designation"}
                  text={data?.class_enrolled?.host_designation || '-'}
                />
                <LineRow
                  heading={"Host Experience"}
                  text={data?.class_enrolled?.host_experience || '-'}
                />
                <LineRow
                  heading={"Meeting Link"}
                  text={data?.class_enrolled?.meeting_link || '-'}
                />
                {data?.class_enrolled?.image_url && (
                  <div className="w-100 rounded-4">
                    <img
                      alt=""
                      src={data?.class_enrolled?.image_url === null ? '/images/user-placeholder.jpeg' : data?.class_enrolled?.image_url}
                      width={"100%"}
                      height={200}
                    />
                  </div>
                )}
              </Col>
              <Col sm={12} md={6}>
                <p className="fw-bold">Nurse :</p>
                <UserAvatarWithNameAndTag
                  userName={`${
                    data?.nurse.firstname && data?.nurse.firstname !== null
                      ? data?.nurse.firstname
                      : ""
                  } ${
                    data?.nurse.lastname && data?.nurse.lastname !== null
                      ? data?.nurse.lastname
                      : ""
                  }`}
                  avatarImage={data.nurse.image_url === null ? '/images/user-placeholder.jpeg' : data.nurse.image_url}
                />
                <LineRow heading={"About"} text={data.nurse.about  || '-'} />
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default ClassEnrollmentModal;
